<template>
  <div class="app-container">


    <el-row style="margin-bottom: 18px;">
      <el-radio-group v-model="ValuationType" @change="handleChange">
        <el-radio :label="0">按仓库+存货</el-radio>
        <el-radio :label="1">按存货</el-radio>
      </el-radio-group>
    </el-row>
    <!-- <el-row>
      <el-checkbox v-model="b">批号和计价法联用</el-checkbox>
    </el-row> -->
  </div>
</template>
<script>
// import editDialog from "@/components/basedata/finance/valuation/editDialog";
// import importDialog from "@/components/basedoc/valuation/importDialog";

export default {
 data(){
   return {
      api: require('@/api/sy/option').default,
      ValuationType: 0,
      b: false
    };
 },
 created(){
  this.api.getValuationSetting().then(res => {
    if(res.Code === 0){
      this.ValuationType = res.Data.ValuationType;
    }
  })
 },
 methods: {
  handleChange(ValuationType){
    this.api.valuationSettingSave({ValuationType}).then(res => {
      if(res.Code === 0){
        this.$message({
          type: 'success',
          message: res.Msg
        })
      }else{
        this.$message({
          type: 'warning',
          message: res.Msg
        })
      }
    })
    console.log('ValuationType', ValuationType)
  }
 }
  
};
</script>